import React from "../../__compat__/react/main.entry.mjs.mjs";
import { FormHelperText } from "../FormHelperText/index.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { FormLabel } from "../FormLabel/index.mjs.mjs";
import { StyledFieldset } from "./FormGroup.styles.mjs.mjs";
export const FormGroup = React.forwardRef(({ 'data-testid': testId, children, className, disabled, hideLabelOptional, hint, id, invalid = false, label, required, validationMessage, ...restProps }, ref) => {
    const hintMessageId = `${id}__hint-message`;
    const errorMessageId = `${id}__error-message`;
    const describedBy = [hint ? hintMessageId : '', invalid ? errorMessageId : '']
        .join(' ')
        .trim() || undefined;
    return (React.createElement(StyledFieldset, { "aria-describedby": describedBy, className: className, "data-testid": testId, disabled: disabled, id: id, outerSpacing: useSpacing(restProps), ref: ref },
        label && (React.createElement(FormLabel, { as: "legend", spaceStackEnd: 's', required: required, invalid: invalid, disabled: disabled, hideLabelOptional: hideLabelOptional }, label)),
        children,
        hint && (React.createElement(FormHelperText, { id: hintMessageId, spaceStackStart: 's', variant: "hint" }, hint)),
        invalid && (React.createElement(FormHelperText, { id: errorMessageId, spaceStackStart: hint ? 'xxs' : 's', variant: "invalid" }, validationMessage))));
});
FormGroup.displayName = 'FormGroup';
//# sourceMappingURL=FormGroup.mjs.mjs.map